import { render, staticRenderFns } from "./SafeAreaBottom.vue?vue&type=template&id=2a1a00d0&scoped=true"
import script from "./SafeAreaBottom.vue?vue&type=script&lang=js"
export * from "./SafeAreaBottom.vue?vue&type=script&lang=js"
import style0 from "./SafeAreaBottom.vue?vue&type=style&index=0&id=2a1a00d0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a1a00d0",
  null
  
)

export default component.exports